import ServicesContainer from "../../../components/pages/other/services";

const Services = () => {
  return <ServicesContainer />;
};

export default Services;
